export default {
  commonTxt: {
    nodata: "データなし",
    loading: "ロード中",
    more: "もっと"
  },
  main: {
    logo: "臨床試験被験者募集サイト",
    slide: {
      title: "アクセスが多い研究",
      detail: "詳細"
    },
    closing: {
      title: "募集期間締切公告",
      txt: "日後、募集終了"
    },
    research: {
      tabTitle1: "健常人参加研究",
      tabTitle2: "患者参加研究"
    },
    counter: {
      count1: "今年支援した被験者数",
      count2: "今年総進行研究数",
      count3: "現在進行中研究数",
      persons: "名",
      case: "件"
    },
    banner: {
      txt1:
        "カカオトーク Plus カカともを追加すると\n1:1で速く楽にお問い合わせできます",
      txt2: "「Plus カカとも」ソウル大学校臨床試験センター",
      txt3: "+ 追加方法確認"
    }
  },
  login: {
    placeholderId: "メールアドレス(ID)入力",
    placeholderPw: "パスワード入力",
    buttonTxt: "ログイン",
    user: "様",
    logout: "ログアウト",
    mypage: "マイページ",
    saveId: "ID保存",
    signIn: "新規登録",
    findId: "ユーザID確認",
    findPw: "パスワード確認"
  },
  join: {
    title: "新規登録",
    titleStep1: "ユーザ情報作成",
    titleStep2: "臨床試験の志願書作成",
    password: "パスワード",
    confirmPw: "パスワードチェック",
    duplicate: "※ すでに登録されているメールアドレスです。",
    always: "常時支援申し込み",
    alwaysTxt:
      " * 常時支援を申し込む場合、各臨床試験の募集担当者が参加可能かどうかを確認するために連絡をする場合があります。",
    btnJoin: "新規登録する",
    btnCancel: "キャンセル",
    alertCancel: "新規登録をキャンセルしますか？",
    failJoin: "新規登録に失敗しました。",
    completeTit: "新規登録を完了しました! ",
    completeTxt1: " ユーザID(メールアドレス)は",
    completeTxt2: "です。",
    completeTxt3: " 志願書と合う募集を確認して支援して見てください。",
    completeBtn: "始める"
  },
  findAccount: {
    titleId: "ユーザID確認",
    titlePw: "パスワード確認",
    titleChangePw: "パスワード変更",
    mail: "メールアドレス",
    placeholderMail: "イーメウール(ID)を入力してください。",
    name: "お名前",
    placeholderName: "お名前を入力してください",
    gender: "性別",
    rdoMale: "男",
    rdoFemale: "女",
    birth: "生年月日",
    phone: "携帯電話番号",
    placeholderPh: "携帯電話番号を入力してください",
    newPw: "新しいパスワード",
    confirmPw: "パスワードチェック",
    btnTxtId: "ユーザID確認",
    btnTxtPw: "パスワード確認",
    btnTxtLogin: "ログイン",
    btnTxtHome: "ホーム",
    btnTxtChange: "パスワード変更",
    btnTxtCancel: "キャンセル",
    idResultTitle: "検索結果",
    idResult:
      "当情報で検索されたIDで、個人情報保護のために一部は*と表記されます。",
    errorId: "検索されたIDがありません",
    errorMail: "※ メールアドレス(ID)、またはパスワードが一致しません。",
    withdrawMail: "退会したメールアドレス(ID)です。",
    alertPw: "パスワード変更しました。",
    errorPw: "パスワード変更に失敗しました。",
    errPwConfirm: "※ 英文 大/小文字+数字+特殊文字 組合9席以上に設定してください。",
    wrongCnt: "許可されたログイン試行回数を超えてログインがブロックされました。カカオトークプラスフレンドソウル大病院臨床試験センターまたは02-741-4221にお問い合わせください。"
  },
  footer: {
    addr:
      "ソウル大学病院 臨床試験センター 韓国ソウル市鐘路区大学路101番地 (蓮建洞28-21)",
    familySite: "ファミリーサイト",
    family: [
      { id: 0, href: "https://www.snu.ac.kr/", txt: "ソウル大学校" },
      {
        id: 1,
        href: "http://medicine.snu.ac.kr/",
        txt: "ソウル大学校医科大学"
      },
      // { id: 2, href: "http://clinpharm.snu.ac.kr/", txt: "ソウル大学校" },
      // {
      //   id: 3,
      //   href: "http://www.snu.ac.kr/index.html",
      //   txt: "ソウル大学大学院協同課程·臨床薬理学専攻ページ"
      // },
      { id: 2, href: "http://www.snuh.org/intro.do", txt: "ソウル大学病院" },
      {
        id: 3,
        href: "http://ctc.snuh.org/",
        txt: "ソウル大学校病院医生命研究院"
      },
      {
        id: 4,
        href: "https://hrpp.snuh.org/pub/_/singlecont/view.do",
        txt: "ソウル大学学校病院臨床研究倫理センター(HRPP)。"
      }
    ]
  },
  navigation: [
    {
      name: "臨床試験センタ",
      children: [
        "センターの紹介",
        "臨床試験参加の意義",
        "手続き案内",
        "スクリーニング検査および入院案内",
        "ソウル大学校病院のアプリ利用案内。"
      ]
    },
    {
      name: "研究情報",
      children: ["臨床試験募集情報"]
    },
    {
      name: "Contact Us",
      children: ["FAQ", "アクセスマップ"]
    },
    {
      name: "私の参加情報",
      children: ["ユーザ情報", "臨床試験支援書", "支援履歴", "QnA"]
    }
  ],
  infomation: {
    txt: "臨床試験センターのボランティア募集センター : ",
    contact: "02-741-4221",
    time: " 平日 AM9:00～PM6:00"
  },
  about: {
    indroduce: {
      title: "ソウル大学病院臨床試験センターの紹介",
      Paragraph1:
        "ソウル大学病院臨床試験センターは「医薬品臨床試験管理基準(KGCP)」とICHおよびFDAガイドラインのような国際的な基準に基づいて、臨床試験が科学的かつ倫理的に行われるよう最適な研究環境を提供することにより、臨床試験実施全般の先進化を図ろうと、1995年に設立されました。以後、2004年には国内初の保健福祉部指定地域臨床試験センターで、過去2012年には、やはり国内で初めて、保健福祉部から臨床試験のグローバルリーディング·センター（GREATS）で指定され、臨床試験の世界的な競争力を確保していきます。",
      Paragraph2:
        "ソウル大学病院臨床試験センターは、成人、腫瘍、小児、医療機器分野別に、それぞれの空間と施設を備え、分野別の特性に合わせて専門的に運営しており、新薬を含む各種医薬品や医療機器の有効性と安全性の評価、生物学的同等性試験などを実施するための基本的な研究人材、研究施設や行政のサポートを提供しています。ソウル大学病院の研究者はもちろん、産学協同研究のために、適切な資格と条件を備えた研究者は、誰でもソウル大学病院臨床試験センターを利用することができます。",
      Paragraph3:
        "ソウル大学病院臨床試験センターは、AAHRPP、WHO FERCAP認証などを介して、臨床研究に参加する研究対象者の権利保護と安全の向上に万全を期しています。ソウル大学病院臨床試験センターで実行される倫理的、科学的な臨床試験にボランティアの方々の積極的な参加を望みます。",
      Paragraph4:
        "詳細内容はソウル大学病院臨床試験センターのホームページを訪問してください。",
      link: "http://ctc.snuh.org/"
    },
    meaning: {
      title: "臨床試験参加の意義",
      Paragraph1:
        "糖尿病やアルツハイマー病、アトピーのような疾患を持つ方を治療するために、もっと効果のある医薬品を開発するのに役立つことができればどうだろうかと想像してみたことがありますか。ソウル大学病院臨床試験センターでは、様々な病気を治療するために臨床試験用医薬品、製薬およびバイオテクノロジーの分野で活発な研究をしている企業とパートナーになって臨床試験を実施しています。ソウル大学病院臨床試験センターの ボランティアになるということは、次のような意味があります。",
      Paragraph2: "オンラインで申し込むか、電話でお問い合わせください。",
      list: [
        {
          id: 1,
          txt:
            "慢性あるいは重症の疾患で苦しむ患者の治療に役立てるというやりがいを感じることができます。"
        },
        {
          id: 2,
          txt: "臨床試験に対して社会の否定的な認識の改善に 力になれます。"
        },
        {
          id: 3,
          txt:
            "試験の種類によっては、総体的な健康診断サービスを受けることができます。"
        },
        {
          id: 4,
          txt:
            "臨床試験に誠実に参加してくださったお礼に謝礼金を受け取ることができます。"
        },
        {
          id: 5,
          txt: "新しい友達ができる機会を提供します。"
        },
        {
          id: 6,
          txt: "日常生活から離れて休息をとれます。"
        },
        {
          id: 7,
          txt:
            "一日訪問して採血する研究から一か月入院して行う研究まで、様々な研究がありますので、本人に 合う日程で参加することができます。"
        }
      ]
    },
    process: {
      title: "程序指南",
      processData: [
        {
          id: 1,
          title: "電話スクリーニング",
          imgName: "process_phone",
          cont: `ホームページまたは電話で臨床試験に申し込む場合、 ボランティアコールセンターと通話します。 ボランティアコールセンターは月曜日〜金曜日の午前9時から午後6時までです。電話スクリーニングの担当者はあなたが研究に基本的な資格があるかをお知らせします。薬の服用関連を含む病歴について質問いたしますので、正直にお答えください。これはあなたが臨床試験を安全に受けるためには欠かせないことです。`
        },
        {
          id: 2,
          title: "スクリーニング時の約束",
          imgName: "process_appointment",
          cont:
            "電話スクリーニングが終わればスクリーニングの約束をします。スクリーニングの前は、通常10時間以上絶食しなければならず、身分証明書を持参して約束の時間に訪問します。約束した時間に訪問しなかった場合は後日研究に参加する機会を得るのに不利益が生じることがありますので、最低一日前にはキャンセルのご連絡をお願いします。\n スクリーニングの前に泊まらなければならない内容は一般的に次の通りです。\n\n -十分な休息と睡眠スクリーニングの前日に十分な睡眠を取らなければ、スクリーニング脱落の可能性が高く、再検査のために再び訪問できるので制限します。"
        },
        {
          id: 3,
          title: "同意書作成",
          imgName: "process_agree",
          cont:
            "事前検査が行われる前に同意書を読んでいただきます。同意書には、全体の研究について非常に詳細な情報が書かれています。この文書には、研究の目的、投与する薬剤の量、採血回数と量、該当する薬剤に関して報告された副作用を含む研究で行われるすべての手順が含まれています。あなたが研究で担う役割と潜在的な危険性について理解するために同意書全体を読んでいただくことは非常に重要です。スタッフが研究について説明し質問についてお答えします。こちらではあなたが同意書を読んで理解したということがわかるように署名を請求しています。"
        },
        {
          id: 4,
          title: "スクリーニング過程",
          imgName: "process_screening",
          cont:
            "研究参加同意書を作成した後は、研究により多少異なりますが、一般的には、まずスクリーニング室で身長、体重、バイタルサイン（体温、血圧、脈拍）を測定し、外来で採血、心電図検査、尿検査をします。検査が終了したら、再度スクリーニング室で身体検査をした後、入院あるいは外来訪問に関して、事前に熟知すべき内容を聞いてから帰宅することができます。スクリーニング過程で必要な時間は研究により多少の差はありますが、研究関連の説明や同意書の作成を含め、約2〜3時間かかります。"
        },
        {
          id: 5,
          title: "ボランティアの選定",
          imgName: "process_vounteer",
          cont:
            "スクリーニングが終わった後、研究者がスクリーニング時に実施した各種検査の結果を確認した後、研究参加可能かどうかについて電話でお知らせします。"
        },
        {
          id: 6,
          title: "入院",
          imgName: "process_hospital",
          cont:
            "研究によって入院時間は異なりますが、通常投薬前日の午後8時まで医生命研究所3階の研究病棟に入院をします。入院病室は、通常4～6人部屋で、同じ性別で構成された病室を使用します。病棟到着後、入院生活についての全体的な説明を聞いて、指定された病室とベッドに行って病衣に着替えます。研究病棟内のバスルームには、シャンプー、石鹸、歯磨き粉、ボディローションなどが備えられており、洗濯室に共用洗濯機があるので洗剤で洗濯をすることができます。入院中の個人の持ち物は、病棟で提供される鍵つきのロッカーに保管でき、入院期間中は、外出、外泊、面会、おやつの摂取は禁止されています。"
        },
        {
          id: 7,
          title: "初日",
          imgName: "process_day1",
          cont:
            "初日は研究により差はありますが、研究の進行期間中、最も多くの手順が行われる日です。すべての研究手順が決められた時間に行われるので、時間をよく守り、同時に正確なデータを確保するために最も多くの人数の研究者が参加します。初日のおおよそのスケジュールは、朝7時50分頃起床し、尿検査をした後、8時から昼食時間まで採血、バイタルサイン、身体検診、心電図などの検査が定められた時間に行われます。投薬は通常8時40分頃に行われ、一日目の朝は通常断食するので、食事は投薬後4時間後から可能で、飲水摂取の場合も、投薬2時間後からできるという制約がある場合があります。"
        },
        {
          id: 8,
          title: "投薬",
          imgName: "process_medication",
          cont:
            "前述したように、通常一日目に投与します。何よりも皆様の安全が最も重要であるため、投薬が行われる日には、研究者が病棟に常駐して継続的にモニタリングします。投薬前と比較してわずかな不便が生じた場合、研究者が迅速にお手伝いをします。"
        },
        {
          id: 9,
          title: "食事",
          imgName: "process_meal",
          cont:
            "断食が必要な場合を除いて入院期間中は食事が提供されます。研究により食事のタイプが決まっていたり、あるいは食事の量が決まっている可能性があり、参加者が食事を 調整できない場合があります。また、食事の時間も研究によって決められた時間だけの食事が可能な場合があります。"
        },
        {
          id: 10,
          title: "活動",
          imgName: "process_acivity",
          cont:
            "ソウル大学病院臨床試験センターの研究病棟は、皆様の快適な便益のために、様々な努力をしています。ベッドごとにテレビを備えつけて、自由にお好きなチャンネルがご覧になれるようにし、休憩室を設け、ビデオゲームやボードゲームを楽しむことができる施設を設けており、漫画や様々な書籍を備え、快適な読書環境を造成しています。また、病棟内に4台のPCが設置されており、簡単にインターネットを利用できるようにしました。病棟のPCより個人のノートPCを希望される場合はノートPCをご持参になっても構いません。"
        },
        {
          id: 11,
          title: "退院",
          imgName: "process_discharged",
          cont:
            "入院期間中決められたすべての研究の手順が終了すれば退院することができます。退院時間の調整は難しく、研究によって異なりますが、朝食後、10時に退院するのが一般的です。"
        },
        {
          id: 12,
          title: "追加訪問または電話",
          imgName: "process_phone",
          cont:
            "再検査などにより追加の訪問が必要な場合があります。このような場合には皆様に直接お電話で連絡をさしあげて訪問をお願いすることがあります。"
        },
        {
          id: 13,
          title: "協力費",
          imgName: "process_reward",
          cont:
            "可能な限り、皆さんの時間と努力を補償いたします。通帳の写しを提出提出していただければ一般的に研究終了後21日以内にご入金されます。"
        }
      ]
    },
    subjectguide: {
      title: "スクリーニング検査および入院案内",
      section1: {
        title: "臨床試験説明会およびスクリーニング検査訪問案内。",
        subTitle: "臨床試験説明会およびスクリーニング検査訪問案内。",
        list: [
          "臨床試験の意義",
          "訪問前の確認事項",
          "訪問前の注意事項",
          "臨床試験の説明会およびスクリーニング検査参加手続き。",
          "同意書及びスクリーニングシートの作成時の注意事項。",
          "臨床試験参加時の制限事項。",
          "検査後の進行過程"
        ]
      },
      section2: {
        title: "入院生活案内",
        subTitle: "研究病棟入院生活案内",
        list: ["入院生活関連", "研究による対象者規則"]
      }
    },
    appguide: {
      title: "ソウル大学校病院のアプリ利用案内。",
      title2: "ソウル大学学校病院モバイルアプリケーション利用案内。",
      cont:
        "ソウル大学校病院はスマートフォン上でホームページを利用されている方のためのソウル大学校病院モバイルアプリケーションを制作しました。\n 病院内で便利に診療を受けることはもちろん、病院外でも簡単に健康管理ができるように様々な機能を提供します。\n アプリにも診療予約、予約日程確認、医療スタッフ紹介、病院情報などを提供しており、グーグルプレイストア、アップルアプリストアで 'ソウル大学病院'を検索して設置することができます。",
      appTxt: "iPhone App",
      androidTxt: "Android App",
      downTxt: "[Download]"
    }
  },
  faq: {
    title: "よくある質問",
    list: [
      {
        id: 0,
        tabName: "よくある質問",
        cont: [
          {
            id: 0,
            tabName: "申し込む",
            que: "私も参加できますか？",
            ans: "それぞれの臨床試験は要求事項が異なります。"
          },
          {
            id: 1,
            tabName: "臨床試験",
            que: "進行中の臨床試験について知ることができますか？",
            ans:
              "「進行中の研究」をご覧になるか、ボランティア募集センターにお電話くだされば、詳しい情報をお知らせいたします。"
          },
          {
            id: 2,
            tabName: "入院",
            que: "家族や友達が訪問することができますか？",
            ans:
              "研究の正確な結果や研究参加者のプライバシーを守るためにこちらでは訪問者を許可していません。病棟内で新しいお友達を作ることをお勧めします。"
          },
          {
            id: 3,
            tabName: "申し込む",
            que: "臨床試験に参加するデメリットとメリットは何ですか？",
            ans:
              "潜在的なデメリットとメリットは、研究ごとに異なり、臨床試験への参加に同意する前に、デメリットとメリットについての説明を聞くことができます。\nまた、説明されていない部分に対して気がかりなことがあれば、医師に質問することができます。"
          },
          {
            id: 4,
            tabName: "申し込む",
            que: "誰が研究に参加することができますか？",
            ans:
              "センターで行われる臨床試験は、一般的に19歳以上でなければ参加できません。医学的な資格要件は研究によって異なります。第1相臨床試験は、研究計画書によって決定された健康な ボランティアの厳格な資格基準を備えた人だけが参加できます。資格基準には、喫煙、医薬品、薬物使用、アルコールなどが含まれることもあります。第2相と第3相臨床試験は、特定の医学的な条件があり、第1相と同様の資格基準を備えた人が参加できます。"
          },
          {
            id: 5,
            tabName: "臨床試験",
            que: "臨床試験とは何ですか？",
            ans:
              "「臨床試験」とは、臨床試験用医薬品の安全性と有効性を証明する目的で、該当薬物の薬動・薬力・薬理・臨床効果を確認し、異常反応を調査するために人を対象として実施する試験や研究のことです。臨床試験はまだ確認されていない事項を知るための学術的な活動であるため、病気の予防・診断・治療のための一般的な方法とは異なる側面があります。臨床試験を通じて、新しい医薬品、医療機器、医療技術が開発された後、これが病気の予防・診断・治療のために使用できる標準的な方法になることがあります。"
          },
          {
            id: 6,
            tabName: "申し込む",
            que: "申込後にキャンセルはできますか？",
            ans:
              "はい、可能です。\n\n 臨床試験は自主的に参加するものなので、健康診断の途中、あるいは臨床試験に参加している途中でも、自由に同意撤回ができ、いかなる不利益も発生しません。ただし、臨床試験の途中に撤回した場合は、検診のために医師が再訪問を請求することがあります。"
          },
          {
            id: 7,
            tabName: "臨床試験",
            que: "私の情報の秘密は維持されますか？",
            ans:
              "個人情報は、ソウル大学病院のスタッフによって保護され、法律によって要求されない限り、皆様の医療情報は提供されません。臨床試験依頼機関および食品医薬品安全庁などの関連規制機関は、医療記録と身元確認のために名前、住所などの個人情報を確認することもあり、必要に応じて検査期間中にコピーすることもあります。\n このように情報を使用する必要があるため個人情報は絶対に保護されるということはありません。"
          }
        ]
      },
      {
        id: 1,
        tabName: "臨床試験",
        cont: [
          {
            id: 0,
            que: "進行中の臨床試験について知ることができますか？",
            ans:
              "「進行中の研究」をご覧になるか、ボランティア募集センターにお電話くだされば、詳しい情報をお知らせいたします。"
          },
          {
            id: 1,
            que: "臨床試験とは何ですか？",
            ans:
              "「臨床試験」とは、臨床試験用医薬品の安全性と有効性を証明する目的で、該当薬物の薬動・薬力・薬理・臨床効果を確認し、異常反応を調査するために人を対象として実施する試験や研究のことです。臨床試験はまだ確認されていない事項を知るための学術的な活動であるため、病気の予防・診断・治療のための一般的な方法とは異なる側面があります。臨床試験を通じて、新しい医薬品、医療機器、医療技術が開発された後、これが病気の予防・診断・治療のために使用できる標準的な方法になることがあります。"
          },
          {
            id: 2,
            que: "臨床試験に参加することは危険なのでしょうか？",
            ans:
              "臨床試験がどれほどリスクがあるかはそれぞれの臨床試験によって異なり、 治験審査委員会（IRB）は臨床試験のリスクがどの程度なのかと、リスクに備えるため用意された方法が適切かどうかを確認し、臨床試験の実施を承認します。したがって、臨床試験のリスクは、臨床試験の計画段階で最小限に抑えることができます。もちろん、治験責任医師が臨床試験を実行する過程で、リスクを継続的に管理します。"
          },
          {
            id: 3,
            que: "臨床試験に参加すると、開発中の薬を飲むことになりますか？",
            ans:
              "臨床試験中には、開発中の薬だけでなく、既に開発された薬やプラセボ（偽薬）を使用する臨床試験もあります。したがって、すでに開発された薬やプラセボ（偽薬）を飲んでもらう対照群に被験者が配置される場合には、開発中の薬を飲まない場合があります。"
          },
          {
            id: 4,
            que: "新しい薬はどのように承認されるのですか？",
            ans:
              "広範なテストと承認過程を経なければなりません。まず、臨床試験用医薬品は厳格な非臨床試験が行われます。規制機関によって、次の段階が許可されれば、臨床試験を通じて人への安全性のための試験が実施されます。その後、規制機関が承認をした場合、臨床試験用薬物は障害を持つ患者さんを対象として、安全性と有効性を 確認します。その後スポンサーは薬物の承認/拒否、あるいは追加試験を必要とするというレポートを規制機関に提出します。"
          },
          {
            id: 5,
            que: "申込後にキャンセルはできますか？",
            ans:
              "はい、可能です。\n\n 臨床試験は自主的に参加するものなので、健康診断の途中、あるいは臨床試験に参加している途中でも、自由に同意撤回ができ、いかなる不利益も発生しません。ただし、臨床試験の途中に撤回した場合は、検診のために医師が再訪問を請求することがあります。"
          },
          {
            id: 6,
            que: "臨床試験参加者の権利と福祉はどのように保護されますか？",
            ans:
              "臨床試験は資格のある医療スタッフによって行われます。\n\n また、臨床試験参加者を保護する規定と臨床試験実施方法についての基準があります。例えば、治験審査委員会（IRB、Institutional Review Board）は、研究計画書と関連資料を検討し、研究が科学的かつ倫理的に行われるようにします。IRBは臨床試験参加者へ、研究が行われている理由や実行過程、関連のあるデメリットやこれまでの研究の結果を含む情報を与える過程を監督するようになります。"
          },
          {
            id: 7,
            que: "私の情報の秘密は維持されますか？",
            ans:
              "個人情報は、ソウル大学病院のスタッフによって保護され、法律によって要求されない限り、皆様の医療情報は提供されません。臨床試験依頼機関および食品医薬品安全庁などの関連規制機関は、医療記録と身元確認のために名前、住所などの個人情報を確認することもあり、必要に応じて検査期間中にコピーすることもあります。\n このように情報を使用する必要があるため個人情報は絶対に保護されるということはありません。"
          }
        ]
      },
      {
        id: 2,
        tabName: "協力費",
        cont: [
          {
            id: 0,
            que: "協力費がありますか？",
            ans:
              "はい。参加者の皆様は、時間と研究参加に対する協力費を受け取ることができます。協力費は、研究期間や種類によって異なり、具体的な協力費は現在進行中の研究で確認することができます。"
          },
          {
            id: 1,
            que: "協力費はどのようにして受け取るのですか？",
            ans: "研究終了3週間以内に通帳に入金されます。"
          }
        ]
      },
      {
        id: 3,
        tabName: "申し込む",
        cont: [
          {
            id: 0,
            que: "私も参加できますか？",
            ans: "それぞれの臨床試験は要求事項が異なります。"
          },
          {
            id: 1,
            que: "臨床試験に参加するデメリットとメリットは何ですか？",
            ans:
              "潜在的なデメリットとメリットは、研究ごとに異なり、臨床試験への参加に同意する前に、デメリットとメリットについての説明を聞くことができます。\n\n また、説明されていない部分に対して気がかりなことがあれば、医師に質問することができます。"
          },
          {
            id: 2,
            que: "女性も参加できますか？",
            ans:
              "はい。すべての年齢層の男女が参加できます。\n\n 実際に閉経後の女性を含む女性ボランティアを必要としています。"
          },
          {
            id: 3,
            que: "申込後にキャンセルできますか？",
            ans:
              "はい、可能です。\n\n 臨床試験は自主的に参加するものなので、健康診断の途中、あるいは臨床試験に参加している途中でも、自由に同意撤回ができ、いかなる不利益も発生しません。ただし、臨床試験の途中に撤回した場合は、検診のために医師が再訪問を請求することがあります。"
          },
          {
            id: 4,
            que: "同時に一つ以上の研究に参加することができますか？",
            ans:
              "いいえ。\n\n ボランティアは臨床試験が終わった時点から、別の臨床試験が開始される時点まで、1〜3か月の間隔を置いて参加しなければなりません。"
          },
          {
            id: 5,
            que: "臨床試験にどのくらいの間隔で参加することができますか？",
            ans:
              "臨床試験を完了してから1〜3か月の休薬期間が必要です。\n\n その後、自由に他の臨床試験に参加することができます。"
          },
          {
            id: 6,
            que: "ボランティアの義務は何ですか？",
            ans:
              "参加する研究の種類に応じて、正確な試験結果を得るために守らなければならない条件があります。例えば、運動、喫煙、薬物やアルコールに対する制限も含まれることがあります。当センターは、皆様が研究に参加される前にこれらの義務をお知らせしています。"
          },
          {
            id: 7,
            que: "予定されている臨床試験についてどこで見ることができますか？",
            ans:
              "現在進行中の研究をクリックすると、研究についてのより多くの情報がご覧になれます。臨床試験の件名、日付、協力費だけでなく、募集している ボランティアのタイプについての詳細情報を提供しています。"
          },
          {
            id: 8,
            que: "誰が研究に参加することができますか？",
            ans:
              "センターで行われる臨床試験は、一般的に19歳以上でなければ参加できません。医学的な資格要件は研究によって異なります。第1相臨床試験は、研究計画書によって決定された健康な ボランティアの厳格な資格基準を備えた人だけが参加できます。資格基準には、喫煙、医薬品、薬物使用、アルコールなどが含まれることもあります。第2相と第3相臨床試験は、特定の医学的な条件があり、第1相と同様の資格基準を備えた人が参加できます。"
          },
          {
            id: 9,
            que: "研究はどのように進行されるのですか？",
            ans:
              "第1相臨床試験に参加するようになれば通常は1日またはそれ以上の期間、病棟に入院をすることになり、何度も通院をしたり、家で薬の服用をしたりすることがあります。入院期間や通院の回数は、該当する研究によって異なります。入院期間中何回か採血、身体検査、バイタルチェックなどがあり、検査が行われない時間は、本を読んだり、勉強したり、テレビを見たり、ゲームやボードゲーム、インターネットをご利用することができます。"
          },
          {
            id: 10,
            que: "薬の服用中にも参加できますか？",
            ans:
              "参加する臨床試験によって異なります。それぞれの臨床試験は、異なる要件を持っています。ほとんどの健康ボランティア臨床試験の場合、薬を服用している場合は参加できない場合があります。もし、短期治療中の場合であれば治療が終わっての参加が可能でしょう。しかし、患者対象の研究の場合であれば、薬を服用中でも可能な場合があり、臨床試験は薬を服用できるように設計されています。薬の服用についての質問がある場合は ボランティア募集センターまでご連絡ください。"
          }
        ]
      },
      {
        id: 4,
        tabName: "事前検査 (スクリーニング)",
        cont: [
          {
            id: 0,
            que: "事前検査では何をするのですか？",
            ans:
              "- 身分証明書を確認します。\n\n- 医療スタッフが研究について説明し、質問を受けます。\n\n- あなたがこの研究の参加に同意する場合は同意書に署名をします。\n\n- 詳しい医学的、社会的情報を収集します。\n\n- 血液、尿サンプルを収集します。\n\n- 血圧、脈拍、心電図をはかります。\n\n - 検査結果が出たらご連絡して、次のステップについてお知らせします。"
          },
          {
            id: 1,
            que: "事前検査はどのくらいかかりますか？",
            ans:
              "検査に必要な時間は、研究によって異なります。多くの場合は平均2〜3時間かかります。"
          },
          {
            id: 2,
            que: "なぜ、研究参加時には毎回事前検査をするのですか？",
            ans:
              "事前検査は、臨床試験に参加することができる人を選ぶための過程です。臨床試験は、比較的少人数を対象とするため、良いデータが提供できる研究に必要な資格を備えた人が参加しなければなりません。医師が各研究に参加できる人を選択するために検査の結果を参照します。"
          },
          {
            id: 3,
            que: "事前検査で脱落するとどうなるのですか？",
            ans:
              "事前検査で脱落する場合は多くの理由がありますが、理由が何であっても気になることは、すべてお答えいたしますので、ご心配いりません。そして、後日または現在進行中の他の研究にもう一度申し込めるかどうか、 ボランティア募集センターにお問い合わせ下さい。"
          }
        ]
      },
      {
        id: 5,
        tabName: "入院",
        cont: [
          {
            id: 0,
            que: "入院しなければなりませんか？",
            ans:
              "参加する研究によって異なります。ある時は1回の通院と一晩入院するだけの場合もありますが、通常の場合臨床試験の結果を監督する必要があるため、もっと長く入院していただきます。病棟内では自由にお過ごしいただけます。"
          },
          {
            id: 1,
            que: "入院時には何を持参すればいいのですか？",
            ans:
              "トイレに石鹸、シャンプー、歯磨き粉、ドライヤーが備わっており、入院着、毛布、タオル、スリッパ、使い捨てカミソリ、コップ、歯ブラシ（2回以上入院時、初回のみ）が提供されます。必要な場合は化粧品、シャワー用品、下着、読み物、ノートPCなどを持参することができ、センターでは個人の物の紛失または盗難に対して責任を負いません。"
          },
          {
            id: 2,
            que: "携帯電話やノートPCは使用可能ですか？",
            ans: "はい、持ってきて使うことができます。"
          },
          {
            id: 3,
            que: "外出することができますか？",
            ans:
              "ほとんどの場合は入院中病棟の外に出ることができず、長期入院の場合は医師の同意を得て外出することができます。"
          },
          {
            id: 4,
            que: "決められた日に参加しなければなりませんか？",
            ans:
              "はい。それぞれの臨床試験は、参加する日が決まっているので 決められた日にセンターを訪問しなければなりません。\n\n 臨床試験の研究デザインは多様ですが、薬がどのように作用しているかを見るためには決められた時間にデータを収集することが重要です。このため、参加者はセンターで案内された日付と時刻をよく守ってセンターを訪問しなければなりません。\n\n しかし、入院ではなく訪問の場合は研究によって調整できる場合もありますので、 ボランティア募集センターにお問い合わせください。"
          },
          {
            id: 5,
            que: "家族や友達が訪問することができますか？",
            ans:
              "研究の正確な結果や研究参加者のプライバシーを守るためにこちらでは訪問者を許可していません。病棟内で新しいお友達を作ることをお勧めします。"
          }
        ]
      }
    ]
  },
  recruit: {
    all: "すべて",
    male: "男",
    female: "女",
    koreanAge: "만",
    month: "ヶ月",
    currency: "ウォン",
    age: "歳"
  },
  recruitList: {
    title: "臨床試験募集情報",
    alertAge: "年齢を入力してください。",
    alertEnt: "参加可能期間を入力してください。",
    alertHeight: "身長を入力してください。",
    alertWeight: "体重を入力してください。",
    pagingResult: " 件の検索結果",
    buttonReset: "リセット",
    buttonSubmit: "検索",
    buttonTxt: "参加可能な研究だけを検索",
    search: {
      disease: "疾患分類",
      gender: "性別",
      age: "年齢",
      smoking: "喫煙の有無",
      term: "参加期間",
      height: "身長",
      weight: "体重",
      history: "病歴",
      select: "病歴選択"
    },
    searchRdo: {
      all: "すべて",
      male: "男",
      female: "女",
      smoking: "喫煙",
      nonSmoking: "禁煙",
      input: "入力",
      none: "なし",
      yes: "あり"
    },
    loding: "ロード中",
    noResult: "結果なし"
  },
  recruitView: {
    viewTitle: "臨床試験の詳細内容",
    buttonMember: "会員申し込み",
    buttonNonMember: "非会員申し込み",
    cancerTxt: "※腫瘍研究の場合、電話支援のみ可能です。 連絡先 : ",
    closedTxt: "終了した募集公告です。",
    title: {
      apply: "支援方法",
      gender: "性別",
      age: "年齢",
      classify: "研究分類",
      type: "臨床試験の種類",
      term: "参加期間",
      sector: "支援部門",
      smoker: "喫煙の有無",
      smokerY: "喫煙者参加可能",
      smokerN: "喫煙者参加不可",
      cancer: "癌の種類",
      disease: "疾患名",
      history: "病歴",
      participation: "参加期間",
      reward: "協力費",
      recruitPeriod: "募集期間",
      researchPeriod: "研究期間",
      professor: "担当教授",
      stage: "進捗状況",
      medicine: "臨床試験薬剤",
      patient: "対象患者",
      info: "追加情報",
      details: "詳細項目",
      files: "添付ファイル"
    }
  },
  recruitWrite: {
    cancelTxt: "キャンセル",
    nextTxt: "次へ",
    submitTxt: "申し込み",
    cancelMsg: "募集申し込みをキャンセルしますか？",
    submitMsg: "募集の申し込みを進みますか？",
    successMsg:
      "申込みが完了しました。当募集条件により、脱落する恐れがありますので、ご了承ください",
    failMsg: "被験者申し込みに失敗しました。",
    alreadyMsg: "すでに申し込んだ公告です。",
    recruitTitle: {
      name: "お名前",
      mail: "メールアドレス(ID)",
      phone: "携帯電話番号",
      contact: "その他の連絡先",
      birth: "生年月日",
      gender: "性別",
      genderMale: "男",
      genderFemale: "女",
      addr: "住所",
      joinPath: "加入経路",
      preferrede: "好みの連絡方法",
      rank1: "1順位",
      rank2: "2位",
      rank3: "3位",
      rank4: "4位",
      rank5: "5位",
      nation: "民族",
      sector: "支援部門",
      height: "身長",
      weight: "体重",
      smoking: "喫煙の有無",
      history: "病歴",
      type: "臨床試験の種類",
      disease: "疾患分類",
      term: "新しい研究参加可能期間",
      bloodDonation: "献血",
      donationDay: "最近献血日",
      donationType: "最近献血タイプ",
      donationType1: "成分",
      donationType2: "全血",
      bloodTransfusion: "輸血",
      transfusionDay: "最後の輸血日",
      joined: "臨床試験/\n生物学的同等性試験参加経験最後の投与日",
      joinedDay: "最後の投与日",
      joined3month:
        "6ヵ月以内に臨床試験の参加有無\n生物学的同等性試験の参加有無",
      joined3Day: "最後の参加日",
      drug: "薬物使用有無",
      drugName: "薬物名",
      drugDay: "最後の投与日",
      drugTxt:
        "例)30日以内使用した専門医薬品(例:病院で処方された薬、治療を要するほどの特定疾患で長期間、医薬品を服用など)、一般医薬品(例:消化剤、風邪薬、人工涙、目薬、縁故、パスなど)すべて記載",
      allergy: "アレルギー薬物過敏性種類",
      allergyType: "種類",
      allergyDay: "最初の発生日",
      allergyTxt:
        " 例)アトピー皮膚炎、鼻炎、食べ物のアレルギー、喘息、抗生剤/アスピリン/消炎鎮痛剤過敏反応など",
      operation: "手術/手術の予定有無",
      operationType: "手術/施術名",
      operationTxt: "例) 臨床試験期間内に予定された手術や施術/抜歯など",
      surgery: "病歴/手術歴",
      surgeryType: "病名/施術名",
      surgeryTxt:
        "例) 手術/入院治療、治療を要するほどの特定疾患、皮膚疾患(乾線、接触性皮膚炎)や皮内注射が難しい傷跡や皮膚異常、または過去の手術履歴など。",
      smokingYn: "喫煙の有無",
      smokingType: "本/日",
      smokingDay: "最後の喫煙日",
      smokingTxt: "（正確な数を入力してください。）",
      nonSmoking: "非喫煙者",
      smoked: "過去の喫煙者",
      smoker: "現在喫煙者",
      step3Type: "種類",
      step3Time: "回/週,",
      step3Day: "最後の摂取日",
      alcohol: "飲酒有無",
      alcoholTime: "杯/週,",
      alcoholDay: "最後の飲酒日",
      alcoholTxt: "例)ビール、焼酎、洋酒など",
      caffeine: "カフェイン含有食品摂取有無",
      caffeineTxt:
        "例) コーヒー含有食品、チョコレート含有食品、お茶(例:緑茶、紅茶など)の種類、炭酸飲料(例:コーラなど)、滋養強壮剤(例:コカフェイン飲料など)",
      etcMedicine: "漢方薬/健康機能食品を摂取するかどうか",
      etcMedicineTxt:
        "例)30日以内に摂取した韓方(例:紅参など)または健康機能食品(例:オメガ-3脂肪酸、ビタミンD、カルシウム、総合ビタミンなど)　すべて記載",
      diet: "臨床試験に影響を与えると予想される異常な食事が摂取有無",
      dietTxt:
        "例) たんぱく質、脂肪質中心の食事、菜食だけ摂取、グレープフルーツジュースの摂取など",
      exercise: "運動するかどうか ",
      exerciseDay: "最近の運動日",
      meal: "標準食事の可能有無",
      mealTxt: "*標準食事:病院で提供する食事",
      contraception: "臨床試験期間中、避妊可能かどうか。",
      precautions: "注意事項の順守可能有無",
      precautionsTxt:
        "*注意事項:研究によって異なりますが、臨床試験全期間の間には他の医薬品、漢方薬、健康機能食品を制限して飲酒、喫煙、献血と輸血をしてはならず、臨床試験用の薬品、投与である約1週間前には飲酒、カフェイン含有食品、グレープフルーツ含有食品が禁止されます。 スクリーニング訪問の際は、少なくとも8時間以上、空腹状態を維持し、水をたくさん飲み、身分証を持って来なければなりません。",
      caution:
        "作成した支援書が研究に適する場合、電話で日程案内する予定です。 支援書を書き込みした後、病院へ訪問されても検査結果によっては、参加できない場合もありますので、その際はご了承ください。 電話相談内容は実際の研究参加を意味せず、自発的に病院を訪問した後、医療陣との相談を通じて研究参加の可否が決定されます。 すべての支援者は、検査合格した時にも候補になったり、研究に参加できないことがあります。 検査訪問と脱落した時、交通費と謝礼費は別途支給されません。 上記の内容に同意し、参加申し込みをしますか。"
    }
  },
  agree: {
    title: "ソウル大学病院臨床試験センタ",
    agreeTitle: "個人情報の収集と利用方針同意",
    agreeY: "同意",
    agreeN: "非同義",
    btnCancel: "キャンセル",
    btnSubmit: "次へ",
    agreeMsg: "個人情報の取扱い方針の案内について同意してください。",
    desc: [
      {
        title: "1. 個人情報の収集と利用",
        cont:
          "ソウル大学校病院・臨床試験センターは「情報通信網利用促進及び情報保護などに関する法律」及び「個人情報保護法」に基づき、個人情報の収集と利用に当たっては同意を得るようにします。"
      },
      {
        title: "① 個人情報の収集と利用の目的",
        cont: [
          "ㆍ臨床試験の志願者登録",
          "ㆍ病院が発行する各種イベントのお知らせ、診療情報及び臨床研究情報の提供"
        ]
      },
      {
        title: "② 個人情報の保有・利用の期間",
        cont:
          "情報の収集と利用の目的を達成するまであなたの個人情報を保有できます。"
      },
      {
        title: "③ 収集する個人情報項目",
        cont: [
          "ㆍ氏名、生年月日、性別、民族、加入経路、メールアドレス、メッセンジャーID、電話番号、住所、お好みの連絡方法、脱落理由など研究参加に必要な情報",
          "ㆍ上記と同様の目的で収集されるあなたの敏感情報は以下の通りです。",
          "- 身体情報（身長、体重）",
          "- 過去の診療記録などの病歴など",
          "ㆍその他、ウエブサイトを通じて臨床試験に志願する際に「志願する」フィールドに記載した項目"
        ]
      },
      {
        title: "④ 個人情報の収集と利用に拒否する権利",
        cont:
          "試験対象者または試験対象者の代理人は個人情報の収集を拒否する権利があります。ただし、収集を拒否した場合は、臨床試験に参加できなくなることがあります。"
      },
      {
        title: "2. 個人情報の処理と保有期間",
        cont:
          "ソウル大学校病院臨床試験センターは、法令に基づく個人情報の保有・利用期間、または情報主体から個人情報を収集する際に同意を得た個人情報の保有・利用期間の範囲内で個人情報を処理・保有します。"
      }
    ]
  },
  contact: {
    title: "アクセスマップ",
    subTitle: "臨床試験ボランティア募集のお問い合わせ",
    contactData: [
      {
        id: 0,
        title: "住所",
        cont:
          "ソウル特別市チョンノ・グ テハンノ101（ヨンゴンドン28番地）ソウル大学病院医生命研究院4階"
      },
      {
        id: 1,
        title: "電話番号",
        cont: "82-2-741-4221"
      },
      { id: 2, title: "メールアドレス", cont: "snuhctc@gmail.com" }
    ],
    data: [
      {
        id: 0,
        traffic: "バスをご利用の場合",
        description: [
          {
            id: 0,
            station: "チャンギョングン　ソウル大学病院　下り 「01002」",
            way:
              "青色（幹線バス : 102, 104, 106, 107, 108, 140, 143, 149, 150, 151, 160, 162, 171, 172, 272, 301, 710"
          },
          {
            id: 1,
            station: "チャンギョングン入口　上り 「01224」",
            way: "青色（幹線バス） : 151, 171, 172, 272, 601"
          },
          {
            id: 2,
            station: "ヘファ駅　ソウル大学病院入口　3番出口 前　下り 「01221」",
            way:
              "青色（幹線バス）: 102, 104, 106, 107, 108, 109, 143, 149, 150, 160, 162, 273, 301, 601, 710\n緑色（支線バス） : 2112, チョンノ08"
          },
          {
            id: 3,
            station: "	ヘファ駅　マロニエ公園前　上り",
            way:
              "青色（幹線バス）: 102, 104, 106, 107, 108, 109, 143, 149, 150, 160, 162, 273, 301, 710\n緑色（支線バス） : 2112, チョンノ08, チョンノ12"
          }
        ]
      },
      {
        id: 1,
        traffic: "汽車│空港をご利用の場合",
        description: [
          {
            id: 0,
            station: "ソウル駅	",
            way: "ソウル駅　地下鉄4号線 → ヘフア駅3番出口"
          },
          {
            id: 1,
            station: "ヨンサン駅	",
            way: "シンヨンサン駅　地下鉄4号線 → ヘファ駅　3番出口"
          },
          {
            id: 2,
            station: "キンポ空港",
            way:
              "金浦空港駅　空港鉄道→ソウル駅（4号線に乗り換え）→恵化駅　3番出口（ヘファ駅）"
          },
          {
            id: 3,
            station: "インチョン空港",
            way:
              "仁川国際空港駅　空港鉄道→ソウル駅（4号線に乗り換え）→恵化駅　3番出口（ヘファ駅）"
          }
        ]
      },
      {
        id: 2,
        traffic: "主な高速│市外バスをご利用の場合",
        description: [
          {
            id: 0,
            station: "カンナムターミナル",
            way:
              "高速ターミナル　地下鉄3号線 → チュンムロ駅（4号線に乗り換え） → ヘファ駅　3番出口"
          },
          {
            id: 1,
            station: "南部ターミナル",
            way:
              "	南部ターミナル駅　地下鉄3号線 → チュンムロ駅（4号線に乗り換え） → ヘファ駅3番出口"
          },
          {
            id: 2,
            station: "東ソウルターミナル",
            way:
              "江辺駅（カンビョン駅）　地下鉄2号線→東大門歴史文化公園駅（トンデムンニョクサムナゴンウォン駅）（4号線に乗り換え）→恵化駅　3番出口（ヘファ駅）"
          },
          {
            id: 3,
            station: "サンボンターミナル",
            way:
              "サンボン駅　地下鉄　7号線 → クンジャ駅（５号線に乗り換え） → 東大門歴史文化公園駅（4号線に乗り換え） → ヘファ駅３番出口"
          }
        ]
      }
    ],
    other: {
      traffic: "高速道路（自家用車）をご利用の場合",
      way:
        "京釜線（キョンブ線）　ソウル料金所 → 漢南大橋（ハンナム大橋） → 乙支路（ウルチロ） → イファサゴリ → テハンノ → ソウル大学病院",
      txt:
        "スクリーニング進行者に限り、4時間無料駐車が可能です。過去暦やBMIでスクリーニング参加不可時の駐車料金は自己負担"
    }
  },
  userInfo: {
    infoTitle: "ユーザ情報",
    modifyTitle: "ユーザ情報設定",
    applyTitle: "臨床試験支援書",
    applyModifyTitle: "臨床試験支援書修正",
    joinDate: "加入経路",
    changePw: "パスワード変更",
    male: "男",
    female: "女",
    participation: "参加期間",
    alwaysTit: "いつも",
    btnModify: "登録日脱会日",
    btnWithdraw: "設定退会",
    btnSave: "保存",
    btnCancel: "キャンセル",
    failMsg: "保存に失敗しました。"
  },
  withdrawal: {
    title: "退会",
    section1: {
      tit: "退会案内",
      cont: "退会する前に注意事項を確認してください。"
    },
    section2: {
      tit: "メールアドレス(ID)再使用と復元不可能案内",
      cont:
        "使っているメールアドレス(ID)を退会した場合、再使用または復元ができません。\nご注意してください。"
    },
    section3: {
      tit: "ユーザ情報と個人サービス利用記録削除案内",
      cont:
        "ユーザ情報と臨床試験支援書、支援履歴、問い合わせのサービス利用キルクは全部削除され、削除されたデータは復元できません。"
    },
    step2: {
      tit: "安全な大会をするためにパスワードを確認してください。",
      cont:
        "パスワードの確認が終わったら、メールアドレス(ID)は即時退会されます。使っているメールアドレス(ID)を退会した場合、再使用または復元ができません。\n ご注意してください。"
    },
    form: {
      txt1: " メールアドレス(ID)",
      txt2: "パスワード"
    },
    btnCancel: "退会キャンセル",
    btnStepNext: "次へ",
    btnWithdraw: " 設定退会"
  },
  recruitHistory: {
    title: "支援履歴"
  }
};
